module.exports = __webpack_public_path__ + "static/media/icita2013.11968e0f.png";